import styled from 'styled-components';

export const KakaoSharedButtonLayout = styled.button`
  border: 0;
  background-color: transparent;
  color: var(--gray-900, #181818);
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px; /* 162.5% */
  letter-spacing: -0.16px;
`;
